export class AssessmentPerformedBy {
  static vendor = 0;
  static self = 1;
}
